import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Perks = () => {
  return (
    <div className="Perks p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={7}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              TekRevol’s Web Development <span>Expertise</span>
            </h2>
            <p>
              We do not claim to be #1, but we excel at what we do. With an
              experienced, full-scale in-house team, we have a reliable and
              sought-after web development cycle to produce efficient, secure,
              and growth-compliant products that businesses love.
            </p>
          </Col>
        </Row>
        <Row className="h-100 perks-padd">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  Specializes Modern
                  <br /> Technologies
                </h4>
                <p>
                  Accelerate full-stack development using modern low-code,
                  cloud-based frameworks.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>Result-Driven, Adaptive Workflow</h4>
                <p>
                  We keep the development process simple until it challenges us
                  to scale up resource allocation. On-time project delivery,
                  every time.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  Expertise Across
                  <br /> Industries
                </h4>
                <p>
                  We help businesses across 15+ domains to research, shape, and
                  launch an authoritative web platform.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box perks_web">
              <div className="perks-content">
                <h4>
                  Shorten Time-to- <br />
                  Market
                </h4>
                <p>
                  Reach the masses looking for you online with a fast-loading,
                  friendly, and well-functioning website.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Perks;
